import { AriaHidden } from "@swiggy-private/core-ui";
import { IColors } from "@swiggy-private/dls-web-common/dist/components/types";
import styled, { keyframes } from "styled-components";

const CONTENT_CONTAINER_HEIGHT = "286px";
const CONTENT_CONTAINER_WIDTH = "312px";

export const Container = styled.div(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    borderRadius: theme?.cornerRadius?.large,
    minWidth: "260px",
    position: "relative",
    transform: "translate3d(0, 0, 0)",
    overflow: "hidden",
    background: theme.colors[theme.colorMode].background_Primary,
}));

const roundtime = keyframes`
    to {
        transform: scaleX(0);
    }
`;

export const ContentContainer = styled(AriaHidden)(({ theme }) => ({
    textAlign: "center",
    height: CONTENT_CONTAINER_HEIGHT,
    width: CONTENT_CONTAINER_WIDTH,
    background: theme.colors[theme.colorMode].background_Primary,
    position: "relative",

    "& > img": {
        height: "100%",
        width: "100%",
        objectFit: "contain",
    },
}));

export const FloatingCTA = styled.div(({ theme }) => ({
    position: "absolute",
    bottom: theme?.spacing?.xSmall,
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 1,
}));

export const TimeContainer = styled.div<{ ctaColor?: keyof IColors }>`
    height: 6px;
    transform-origin: right center;
    background: ${({ theme, ctaColor }) => theme?.colors?.[theme.colorMode]?.[ctaColor || "primary"]};
    border-radius: ${({ theme }) => theme.cornerRadius.small};
    animation: ${roundtime} 10s linear forwards;
`;
